import React, { useContext } from 'react';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SiteHeaderDesktop from './SiteHeaderDesktop';
import SiteHeaderMobile from './SiteHeaderMobile';

export interface Props {
  activeMainMenuItem?: string;
  /** Active search query */
  searchQuery?: string;
  /** Base path for when a search is active */
  searchBasePath?: string;
  /** Removes the theme switcher */
  disableThemeSwitcher?: boolean;
  /** Allows disabling of network bar on pages that use it directly, ie. browse */
  showNetworkBar?: boolean;
  /** Removes the fixed positioning of the header */
  disableFixed?: boolean;
  /** Removes most of the header controls for less distractions */
  minimalMode?: boolean;
}

const SiteHeader: React.FC<Props> = props => {
  const isMobile = useContext(MobileContext);
  return isMobile ? (
    <SiteHeaderMobile {...props} />
  ) : (
    <SiteHeaderDesktop {...props} />
  );
};
SiteHeader.displayName = 'SiteHeader';

export default SiteHeader;
